import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getComponentViewByInstance } from '@angular/core/src/render3/context_discovery';
import { BehaviorSubject } from 'rxjs';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class StudentEventDetails{ 
  PlacementRegistrationID :number;
  AcademicInstanceID :number;
  StudentID :number;
  PRNNO:string;  
  StudentName:string;  
} 

@Injectable({
  providedIn: 'root'
})
export class StudEventNotificationService {
  constructor(
    private dataService: DataAccessService) {
  }
  
  public GetPersonalInformation(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetPreStudentInformationListByID?StudentID='+ StudentID + ""; // setting method name from API controller.
    return this.dataService.getAll<StudentEventDetails[]>()
  } 
  
  public GetEventDetailsListByStudentId(StudentID,AcademicInstanceID,EventID) {
    this.dataService.setControllerName = '/BasicEvent/';
    this.dataService.setMethodName = 'GetEventDetailsListByStudentId?StudentID='+ StudentID + '&AcademicInstanceID=' + AcademicInstanceID  + '&EventID=' + EventID + '';
    return this.dataService.getAll<StudentEventDetails[]>()
  } 

  
  public GetPreStudentEnrolmentByPrnNo(PRNNO, StudentID, StudentEnrolmentID, CollegeID, ExamInstanceID) {
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'GetPreStudentEnrolmentByPrnNo?PRNNO='  + PRNNO + '&StudentID='+ StudentID + '&StudentEnrolmentID=' + StudentEnrolmentID + '&CollegeID=' + CollegeID  + '&ExamInstanceID=' + ExamInstanceID + '';
    return this.dataService.getAll<StudentEventDetails[]>()
  } 

  
  public GetStudentDetailsByStudentIDForNotification(StudentID, CollegeID, ExamInstanceID) {
    this.dataService.setControllerName = '/BasicNotification/';
    this.dataService.setMethodName = 'GetStudentDetailsByStudentIDForNotification?StudentID='+ StudentID + '&CollegeID=' + CollegeID  + '&ExamInstanceID=' + ExamInstanceID + '';
    return this.dataService.getAll<StudentEventDetails[]>()
  } 
  
  
  public GetNotificationDetailsListByStudentId(StudentID,  AcademicInstanceID, CourseID, BranchID, CoursePartID, DivisionID, CollegeID) {debugger
    this.dataService.setControllerName = '/BasicNotification/';
    this.dataService.setMethodName = 'GetNotificationDetailsListByStudentId?StudentID='+ StudentID + '&AcademicInstanceID=' + AcademicInstanceID + '&CourseID=' + CourseID + '&BranchID=' + BranchID + '&CoursePartID=' + CoursePartID  + '&DivisionID=' + DivisionID   + '&CollegeID=' + CollegeID + '';
    return this.dataService.getAll<StudentEventDetails[]>()
  } 
  public GetBasicEventList(EventID) {
    this.dataService.setControllerName = '/BasicEvent/';
    this.dataService.setMethodName = 'GetBasicEventList?EventID='+ EventID + '';
    return this.dataService.getAll<StudentEventDetails[]>()
  } 
}
